import { useEffect, useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import './modal.css';
import AddFeedback from '../../roles/customer/AddFeedback';
import AddFeedbackModalCustomer from './AddFeedbackModalCustomerType';
import { useTranslation } from 'react-i18next';
import zIndex from '@mui/material/styles/zIndex';

function ReactModal({ componentToRender, size = 'lg', fullscreen = false, parentbutton = false, modalId, centered = false, style, ...props }) {
  const closeRef = useRef();
  const { i18n, t } = useTranslation();
  return (
    <Modal
      show={props.show}
      onHide={props.handleClose}
      backdrop="static"
      keyboard={false}
      size={size}
      id={modalId}
      fullscreen={fullscreen}
      centered={centered}
      animation={true}
      style={style?style:{}}
    >
      <Modal.Header closeButton>
        <Modal.Title>{props.title}</Modal.Title>
        {parentbutton && <Button variant="primary" onClick={props.additionalButtonAction}>
          {t('general.button.message.text')}
        </Button>}
      </Modal.Header>
      <Modal.Body>
        {/* <AddFeedbackModalCustomer></AddFeedbackModalCustomer> */}
        {componentToRender}
      </Modal.Body>
      {/* <Modal.Footer>
        <button onClick={props.handleClose}>CLOSE</button>
      </Modal.Footer> */}
    </Modal>

  );
}

export default ReactModal;